
import {
  SAVE_CLIENT_APPOINTMENTS,
  SAVE_CLIENT_DIAGNOSIS,
} from '../actions/types';

const initialState = {
  appointmentList: [],
};

export const AppointmentReducer = (state = initialState, action: any) => {
  const oldState = { ...state };
  const { type, payload } = action;
  switch (action.type) {
    case SAVE_CLIENT_APPOINTMENTS:
      return {
        ...state,
        appointmentList: payload,
      };

    default:
      return { ...state };
  }
};
